import { render, staticRenderFns } from "./SideBarFilter.vue?vue&type=template&id=1bcc4ad2&scoped=true"
import script from "./SideBarFilter.vue?vue&type=script&lang=js"
export * from "./SideBarFilter.vue?vue&type=script&lang=js"
import style0 from "./SideBarFilter.vue?vue&type=style&index=0&id=1bcc4ad2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcc4ad2",
  null
  
)

export default component.exports